export class FormsExpressionDefinitionApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getFormBundleExpressionDefinition() {
    return this.#http.get('/api/ExpressionDefinition/form-bundle');
  }

  async getRoleBasedSigningExpressionDefinition() {
    return this.#http.get('/api/ExpressionDefinition/role-based-signing');
  }
}
